import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { ShowString } from "../../../common/controls";
import { EmailVerificationIndicator } from "../../../common/controls/EmailVerificationIndicator";
import { ShowBoolean } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type PublisherRepresentativeViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  nameValue?: { displayId: string; id: string } | null;
  name: string;
  roleValue?: { displayId: string; id: string } | null;
  role: string;
  emailValue?: { displayId: string; id: string } | null;
  email: string;
  phoneValue?: { displayId: string; id: string } | null;
  phone: string;
  isSignerValue?: { displayId: string; id: string } | null;
  isSigner: boolean;
};

export const PublisherRepresentativeViewForm: React.FC<PublisherRepresentativeViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      name = "",
      role = "",
      email = "",
      phone = "",
      isSigner = false,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupPublisherRepresentativeLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowMultiLine
                  value={name}
                  label={langStore.PublisherRepresentativeNameLabel}
                />
                <ShowMultiLine
                  value={role}
                  label={langStore.PublisherRepresentativeRoleLabel}
                />
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <ShowString
                    value={email}
                    label={langStore.PublisherRepresentativeEmailLabel}
                  />
                  <EmailVerificationIndicator
                    email={email}
                    entityName="PublisherRepresentative"
                  />
                </Box>
                <ShowMultiLine
                  value={phone}
                  label={langStore.PublisherRepresentativePhoneLabel}
                />
                <ShowBoolean
                  value={isSigner}
                  label={langStore.PublisherRepresentativeIsSignerLabel}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
